import { Record as record } from 'immutable';
import { construct, fields } from '../../../src/helpers/LinkMapper';

const defaults = {
    id: null,
    moreDetailsRequired: null,
    moreDetailsOptional: null,
    maxTicketDays: null
};

export default class DelayRepayReason extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(DelayRepayReason, json, {
            id: fields.string,
            moreDetailsRequired: fields.bool,
            moreDetailsOptional: fields.bool,
            maxTicketDays: fields.number
        });
    }
}
